<template>
  <div id="app">
    <index-component/>
  </div>
</template>

<script>
import IndexComponent from './components/index-component.vue';
import './index.css';

export default {
  name: 'App',
  components: {
    'index-component': IndexComponent
  }
}
</script>